/**
@ngdoc service
@name processTilesData
@description
assumes tile id present in the data (this will be not necessary once all tiles job is finished as we just ng-repeat the data. for now the mixed tile structures are present in the listing)
*/

(function() {
    'use strict';

	var mapTilesJsonData = function($filter, tileDataFactory,
                                    mapCandidateTileService,
                                    mapManagerTileService,
                                    mapDistributionTileService,
                                    mapItemTileService,
                                    mapProjectTileService,
                                    mapBusinessrecordTileService,
                                    mapInterviewTileService,
                                    mapBookingTileService,
                                    mapCandidatesubmissionTileService,
                                    mapTimesheetTileService,
                                    mapExtensionTileService,
                                    mapPermstartconfirmationTileService,
                                    mapExpenseclaimTileService,
                                    mapTimebasedalertTileService,
                                    mapScreeningcheckitemTileService,
                                    mapScreeningsubcheckTileService,
                                    mapAuditpackTileService,
                                    mapAutomatedsearchTileService,
                                    mapExternaladvertTileService,
                                    mapClientmeetingTileService,
                                    mapHistoryAdHocChargeTileService,
                                    mapHistoryAdminAccessTileService,
                                    mapHistoryAllegationTileService,
                                    mapHistoryAuditPackTileService,
                                    mapHistoryAWRDetailTileService,
                                    mapHistoryBookingInterimTileService,
                                    mapHistoryBookingPermTileService,
                                    mapHistoryBusinessTileService,
                                    mapHistoryCandidateReferenceTileService,
                                    mapHistoryCandidateTileService,
                                    mapHistoryClientMeetingTileService,
                                    mapHistoryCorporateRelationshipTileService,
                                    mapHistoryExpenseClaimTileService,
                                    mapHistoryExtensionTileService,
                                    mapHistoryFrameworkTileService,
                                    mapHistoryHolidayClaimTileService,
                                    mapHistoryInterviewTileService,
                                    mapHistoryMultiStageInterviewsTileService,
                                    mapHistoryItemPermanentTileService,
                                    mapHistoryItemTileService,
                                    mapHistoryProjectTileService,
                                    mapHistoryJobPostingTileService,
                                    mapHistoryJobTempTileService,
                                    mapHistoryManagerTileService,
                                    mapHistoryScreeningManagerTileService,
                                    mapHistoryOrderTileService,
                                    mapHistoryPayChangeTileService,
                                    mapHistoryPermStartConfirmationTileService,
                                    mapHistoryScreeningCheckItemTileService,
                                    mapHistoryScreeningSubcheckTileService,
                                    mapHistoryShiftSlotTileService,
                                    mapHistorySubmissionTileService,
                                    mapHistoryTagApplicationTileService,
                                    mapHistoryTimesheetTileService,
                                    mapHistoryUnknownTileService,
                                    mapHistoryUserTileService,
                                    mapHistoryScreeningCandidateTileService,
                                    mapHistoryScreeningBusinessRecordTileService,
                                    mapHistoryScreeningCaseTileService,
                                    mapHistoryScreeningCaseSubcheckTileService,
                                    mapScreeningbusinessrecordTileService,
                                    mapScreeningmanagerTileService,
                                    mapScreeningcandidateTileService,
                                    mapScreeningcaseTileService,
                                    mapScreeningcasesubcheckTileService,
                                    mapLeadTileService,
                                    mapOfferTileService
    ) {


        // main method of this service
        var mapTilesData = function(data) {
            var rawTilesData = data.dataList;
            var commonLabels = data.labels.common;
            var requesterData = data.requester;

            var mappedTiles = {};

            angular.forEach(rawTilesData, function(rawTile, index){

                var mappedTile = {};

                // Checking if tile type information exists
                if( !angular.isDefined(rawTile.type) ){
                    console.log(rawTile);
                    throw 'Missing tile type.';
                }

                // Checking if tile id information exists
                if( !angular.isDefined(rawTile.id) ){
                    console.log(rawTile);
                    throw 'Missing tile id.';
                }

                var objectTilesLabels = data.labels[rawTile.type];
                var lookupValues = data.labels.lookupValues;
                if(lookupValues==undefined){
                    throw "Unable to find lookupValues within data.labels*.key: "+Object.keys(data.labels) + ' data.labels: '+data.labels;
                    return;
                }

                if(rawTile.businessModel){
                    objectTilesLabels = data.labels[rawTile.type][rawTile.businessModel];
                }

                // Short hand to save having to declare each history type - Warning no objects called ObjectHistory please
                rawTile.historyTile            = rawTile.type.includes('history') ? true : false;
                // Common tiles data
                mappedTile.type                = rawTile.type;
                //Used to style the object type
                mappedTile.historyStyleClass   = getHistoryStyleClass(rawTile);
                mappedTile.title               = mapTitle(rawTile);
                mappedTile.subTitle            = mapSubTitle(rawTile);
                mappedTile.id                  = rawTile.id;
                mappedTile.listingOrder        = index;
                mappedTile.typeLabel           = mapTypeLabel(objectTilesLabels, rawTile);
                mappedTile.checkbox            = rawTile.checkbox;
                mappedTile.favouriteURI        = rawTile.favouriteURI;
                mappedTile.isFavourite         = rawTile.isFavourite;
                mappedTile.recentlyViewed      = rawTile.recentlyViewed;
                mappedTile.viewedURI           = rawTile.viewedURI;
                mappedTile.hasSubmission      = rawTile.hasSubmission;
                mappedTile.submissionURI           = rawTile.submissionURI;
                mappedTile.titleURI            = mapTitleURI(rawTile);
                mappedTile.hasTitleURI         = hasTitleURI(mappedTile.titleURI);
                //External Adverts have links to reed.co.uk adverts so target should be a new window
                mappedTile.titleURITarget      = mapTitleURITarget(mappedTile.titleURI);
                mappedTile.actions             = rawTile.actions;
                mappedTile.actionsLabel        =  commonLabels.actions.label;
                //Tags widget setup
                mappedTile.tagsURI             = rawTile.tagURI;
                mappedTile.tagList             = rawTile.tagList;
                mappedTile.tagsURILabel        = objectTilesLabels ? objectTilesLabels.tagURI ? objectTilesLabels.tagURI.label : '' : '';
                if (objectTilesLabels && objectTilesLabels.tagURI && objectTilesLabels.tagURI.label ) {
                    mappedTile.tagsLabel = objectTilesLabels.tagURI.label;
                } else if (objectTilesLabels &&  objectTilesLabels.tagList && objectTilesLabels.tagList.label) {
                    mappedTile.tagsLabel = objectTilesLabels.tagList.label;
                } else {
                    mappedTile.tagsLabel = '';
                }
                var tileSpecificService = getTileSpecificService(rawTile);
                // console.log('tileSpecificService',tileSpecificService);
                var mappedTileFromService = tileSpecificService.map(rawTile, commonLabels, objectTilesLabels, lookupValues, requesterData);
                // listing type specific (after common section so can overwrite the above it needed)
                // this will be replaced with mappedTiles[rawTile.type+rawTile.id]
                // This has been switched to an index, because for external searches we won't know the id being returned
                mappedTiles[index] = angular.merge(mappedTile, mappedTileFromService );

            });

            return mappedTiles;
        };

        /**
         * Identify which service to use for which object type
         * This is a replacement for eval(). eval() is evil when it comes to security risks. Instead we now have direct declaration
         * @param rawTile
         * @returns service file declaration
         */
        var getTileSpecificService = function(rawTile){
            switch(rawTile.type){
                case 'candidate':
                    return mapCandidateTileService;
                case 'manager':
                    return mapManagerTileService;
                case 'distribution':
                    return mapDistributionTileService;
                case 'item':
                    return mapItemTileService;
                case 'project':
                    return mapProjectTileService;
                case 'businessRecord':
                    return mapBusinessrecordTileService;
                case 'interview':
                    return mapInterviewTileService;
                case 'booking':
                    return mapBookingTileService;
                case 'candidateSubmission':
                    return mapCandidatesubmissionTileService;
                case 'timesheet':
                    return mapTimesheetTileService;
                case 'extension':
                    return mapExtensionTileService;
                case 'permStartConfirmation':
                    return mapPermstartconfirmationTileService;
                case 'expenseClaim':
                    return mapExpenseclaimTileService;
                case 'timebasedAlert':
                    return mapTimebasedalertTileService;
                case 'screeningCheckItem':
                    return mapScreeningcheckitemTileService;
                case 'screeningSubcheck':
                    return mapScreeningsubcheckTileService;
                case 'auditPack':
                    return mapAuditpackTileService;
                case 'automatedSearch':
                    return mapAutomatedsearchTileService;
                case 'externalAdvert':
                    return mapExternaladvertTileService;
                case 'clientMeeting':
                    return mapClientmeetingTileService;
                case 'historyAdHocCharge':
                    return mapHistoryAdHocChargeTileService;
                case 'historyAdminAccess':
                    return mapHistoryAdminAccessTileService;
                case 'historyAllegation':
                    return mapHistoryAllegationTileService;
                case 'historyAuditPack':
                    return mapHistoryAuditPackTileService;
                case 'historyAWRDetail':
                    return mapHistoryAWRDetailTileService;
                case 'historyBookingInterim':
                    return mapHistoryBookingInterimTileService;
                case 'historyBookingPerm':
                    return mapHistoryBookingPermTileService;
                case 'historyBusiness':
                    return mapHistoryBusinessTileService;
                case 'historyCandidateReference':
                    return mapHistoryCandidateReferenceTileService;
                case 'historyCandidate':
                    return mapHistoryCandidateTileService;
                case 'historyClientMeeting':
                    return mapHistoryClientMeetingTileService;
                case 'historyCorporateRelationship':
                    return mapHistoryCorporateRelationshipTileService;
                case 'historyExpenseClaim':
                    return mapHistoryExpenseClaimTileService;
                case 'historyExtension':
                    return mapHistoryExtensionTileService;
                case 'historyFramework':
                    return mapHistoryFrameworkTileService;
                case 'historyHolidayClaim':
                    return mapHistoryHolidayClaimTileService;
                case 'historyInterview':
                    return mapHistoryInterviewTileService;
                case 'historyMultiStageInterviews':
                    return mapHistoryMultiStageInterviewsTileService;
                case 'historyItemPermanent':
                    return mapHistoryItemPermanentTileService;
                case 'historyItem':
                    return mapHistoryItemTileService;
                case 'historyProject':
                    return mapHistoryProjectTileService;
                case 'historyJobPosting':
                    return mapHistoryJobPostingTileService;
                case 'historyJobTemp':
                    return mapHistoryJobTempTileService;
                case 'historyManager':
                    return mapHistoryManagerTileService;
                case 'historyScreeningManager':
                    return mapHistoryScreeningManagerTileService;
                case 'historyOrder':
                    return mapHistoryOrderTileService;
                case 'historyPayChange':
                    return mapHistoryPayChangeTileService;
                case 'historyPermStartConfirmation':
                    return mapHistoryPermStartConfirmationTileService;
                case 'historyScreeningCheckItem':
                    return mapHistoryScreeningCheckItemTileService;
                case 'historyScreeningSubcheck':
                    return mapHistoryScreeningSubcheckTileService;
                case 'historyShiftSlot':
                    return mapHistoryShiftSlotTileService;
                case 'historySubmission':
                    return mapHistorySubmissionTileService;
                case 'historyTagApplication':
                    return mapHistoryTagApplicationTileService;
                case 'historyTimesheet':
                    return mapHistoryTimesheetTileService;
                case 'historyScreeningCase':
                    return mapHistoryScreeningCaseTileService;
                case 'historyScreeningCaseSubcheck':
                    return mapHistoryScreeningCaseSubcheckTileService;
                case 'historyUnknown':
                    return mapHistoryUnknownTileService;
                case 'historyUser':
                    return mapHistoryUserTileService;
                case 'historyScreeningCandidate':
                    return mapHistoryScreeningCandidateTileService;
                case 'historyScreeningBusinessRecord':
                    return mapHistoryScreeningBusinessRecordTileService;
                case 'timeBasedAlert':
                    return mapTimebasedalertTileService;
                case 'screeningBusinessRecord':
                    return mapScreeningbusinessrecordTileService;
                case 'screeningManager':
                    return mapScreeningmanagerTileService;
                case 'screeningCandidate':
                    return mapScreeningcandidateTileService;
                case 'screeningCase':
                    return mapScreeningcaseTileService;
                case 'screeningCaseSubcheck':
                    return mapScreeningcasesubcheckTileService;
                case 'lead':
                    return mapLeadTileService;
                case 'offer':
                    return mapOfferTileService;
                default:
                    if(rawTile.historyTile) {
                        console.warn('No Service has been specified for rawTile.type \'' + rawTile.type + '\' fallen over to mapHistoryUnknownTileService');
                        return mapHistoryUnknownTileService;
                    } else {
                        throw "No Service has been specified for rawTile.type '" + rawTile.type + "'";
                        return;
                    }
            }
        };

        /**
         * Collect the history style class for object type colors
         * For most tiles this is the type without 'history' prefix and lower case the first letter
         * e.g. candidate, manager, timesheet, item, interview
         * The rest are covered by these exceptions
         * @returns {string}
         */
        function getHistoryStyleClass(rawTile){
            if(rawTile.historyTile){
                var historyStyleClass = lowerCaseFirstLetter(rawTile.type.replace('history',''));
                switch(historyStyleClass){
                    case 'bookingInterim':
                    case 'bookingTemp':
                    case 'bookingPerm':
                        historyStyleClass = 'booking';
                        break;
                    case 'itemTemp':
                    case 'itemPerm':
                    case 'jobPosting':
                        historyStyleClass = 'item';
                        break;
                    case 'submission':
                        historyStyleClass = 'candidateSubmission';
                        break;
                    case 'business':
                        historyStyleClass = 'businessRecord';
                        break;
                    case 'holidayClaim':
                        historyStyleClass = 'candidate';
                        break;
                    case 'payChange':
                        historyStyleClass = 'extension';
                        break;
                    case 'user':
                        historyStyleClass = 'client';
                        break;
                }
                return historyStyleClass;
            } else {
                return '';
            }
        }

        function lowerCaseFirstLetter(string){
            return string.charAt(0).toLowerCase() + string.slice(1);
        }

        /**
         * Mapping object specific title label, shared function for all objects
         * @param rawTileData
         * @returns {string}
         */
        function mapTypeLabel(objectTilesLabels, rawTileData, lookupValues){
            var typeLabel = objectTilesLabels ? normalize(objectTilesLabels.object.label) : 'unknown';
            if(rawTileData.type === "booking"){
                typeLabel = rawTileData.bookingPerm ? normalize(rawTileData.bookingPerm) : normalize(rawTileData.bookingInterim);
            }else if (rawTileData.type === "extension") {
                typeLabel = rawTileData.objectMessageOverride;
            }else if (rawTileData.type === "item") {
                typeLabel += ' - ' + (rawTileData.interimJob ? normalize(objectTilesLabels.interimJob.label) : normalize(objectTilesLabels.permanentJob.label));
            }else if (rawTileData.type.indexOf('history') > -1){
                typeLabel = 'History - ' + typeLabel;
            }
            return typeLabel;
        }

        /**
         * Mapping object specific title label, shared function for all objects
         * @param rawTileData
         * @returns {string}
         */
        function mapTitle(rawTileData) {
            var tileTitle = '';
            if (rawTileData.type === "candidate" ||
                rawTileData.type === "manager" ||
                rawTileData.type === "screeningCandidate" ||
                rawTileData.type === "screeningManager") {
                tileTitle = normalize(rawTileData.firstName) + ' ' + normalize(rawTileData.lastName);
            } else if (rawTileData.type === "distribution") {
                tileTitle = normalize(rawTileData.itemTitle);
            } else if (rawTileData.type === "businessRecord" ||
                rawTileData.type === "screeningBusinessRecord") {
                tileTitle = normalize(rawTileData.businessName);
            } else if (rawTileData.type === "booking") {
                tileTitle = normalize(rawTileData.bookingTitle);
            } else if (rawTileData.type === "candidateSubmission") {
                tileTitle = rawTileData.tileTitleCandidateId ? rawTileData.tileTitleCandidateId : rawTileData.tileTitleFirstName + ' '
                    + rawTileData.tileTitleLastName + ' - ' + rawTileData.title;
            } else if (rawTileData.type === "extension") {
                tileTitle = $filter('date')(rawTileData.effectiveDate, "dd/MM/yy") + ' - ' + $filter('date')(rawTileData.newEndDate, "dd/MM/yy");
            } else if(rawTileData.type === "expenseClaim") {
                tileTitle = rawTileData.recordTitle;
            } else if(rawTileData.type === "clientMeeting") {
                tileTitle = rawTileData.managerName + ' - ' + rawTileData.consultant;
            } else if(rawTileData.type === "interview") {
                tileTitle = rawTileData.candidateName + ' - ' + rawTileData.job;
            } else if(rawTileData.type === "screeningCheckItem") {
                tileTitle = rawTileData.candidateName +' - '+$filter('date')(rawTileData.requiredBy, "dd/MM/yyyy");
            } else if(rawTileData.type === "screeningCase" ||
                rawTileData.type === "screeningCaseSubcheck") {
                tileTitle = rawTileData.candidateName;
            }else if(rawTileData.type === "lead") {
                tileTitle = rawTileData.leadName;
            } else if(rawTileData.type === "offer") {
                tileTitle = rawTileData.candidateName + ' - ' + rawTileData.jobTitle;
            } else {
                tileTitle = normalize(rawTileData.title);
            }
            return tileTitle;
        }

        function mapTitleURI(rawTileData){
            var titleURI = rawTileData.editURI;
            switch(rawTileData.type) {
                case 'candidateSubmission':
                    titleURI = rawTileData.showURI;
                    break;
                case 'externalAdvert':
                    titleURI = rawTileData.advertUrl;
                    break;
                case 'distribution':
                    titleURI = (rawTileData.businessModel==='principal') ?
                        rawTileData.itemURI : rawTileData.showURI;
                    break;
            }
            return titleURI;
        }

        function hasTitleURI(titleURI){
            return (titleURI && titleURI.length>0);
        }

        //Identify if URI is an absolute URL or relative URI ?
        function mapTitleURITarget(titleURI){
            //http || https || www
            return (titleURI && (titleURI.startsWith('http')||titleURI.startsWith('www'))) ? '_blank' : '_self';
        }

        // Object specific subtitle mapping
        function mapSubTitle(rawTileData){
            var tileSubTitle;
            if(rawTileData.type === "candidate"){
                tileSubTitle = (rawTileData.currentPreviousJobTitle ? rawTileData.currentPreviousJobTitle : rawTileData.desiredJobTitle);
            }
            return tileSubTitle;
        }

        // Data normalisation function
        function normalize(value){
            return angular.isDefined(value) && value!==null ? value : undefined;
            // not sure yet if I want undefined or ''. undefined seems to be better as it can be tested against easier and it's degraded to '' on output
        }

        // Date time conversion
        function dateTime(datetime) {
            return normalize(datetime) ? $filter('date')(datetime,"EEE dd/MM/yyyy HH:mm") : undefined;
            // maybe some more tests (if conditions) here ie. if datatime is an javascript Date object etc... (can throw exception if now)
            // "EEE dd/MM/yyyy HH:mm" is something what should be pulled from some kind of country config
        }

        // Capitalisation (first letter)
        function capitalize(string) {
           return string.charAt(0).toUpperCase() + string.slice(1);
        }

        // Rate per unit formatting
        function ratePerUnit(rate, unitId, unit) {
            var rateWithCurrency;
            // 320: "per annum"
            (unitId === 320) ? rateWithCurrency = $filter('currency')(rate, "£", 0) : rateWithCurrency = $filter('currency')(rate, "£", 2);
            return (rateWithCurrency ? rateWithCurrency + ' ' : '') + (unit ? unit : '');
        }

        return {
            mapTilesData : mapTilesData
        };
    };

    mapTilesJsonData.$inject = ['$filter', 'tileDataFactory',
        'mapCandidateTileService',
        'mapManagerTileService',
        'mapDistributionTileService',
        'mapItemTileService',
        'mapProjectTileService',
        'mapBusinessrecordTileService',
        'mapInterviewTileService',
        'mapBookingTileService',
        'mapCandidatesubmissionTileService',
        'mapTimesheetTileService',
        'mapExtensionTileService',
        'mapPermstartconfirmationTileService',
        'mapExpenseclaimTileService',
        'mapTimebasedalertTileService',
        'mapScreeningcheckitemTileService',
        'mapScreeningsubcheckTileService',
        'mapAuditpackTileService',
        'mapAutomatedsearchTileService',
        'mapExternaladvertTileService',
        'mapClientmeetingTileService',
        'mapHistoryAdHocChargeTileService',
        'mapHistoryAdminAccessTileService',
        'mapHistoryAllegationTileService',
        'mapHistoryAuditPackTileService',
        'mapHistoryAWRDetailTileService',
        'mapHistoryBookingInterimTileService',
        'mapHistoryBookingPermTileService',
        'mapHistoryBusinessTileService',
        'mapHistoryCandidateReferenceTileService',
        'mapHistoryCandidateTileService',
        'mapHistoryClientMeetingTileService',
        'mapHistoryCorporateRelationshipTileService',
        'mapHistoryExpenseClaimTileService',
        'mapHistoryExtensionTileService',
        'mapHistoryFrameworkTileService',
        'mapHistoryHolidayClaimTileService',
        'mapHistoryInterviewTileService',
        'mapHistoryMultiStageInterviewsTileService',
        'mapHistoryItemPermanentTileService',
        'mapHistoryItemTileService',
        'mapHistoryProjectTileService',
        'mapHistoryJobPostingTileService',
        'mapHistoryJobTempTileService',
        'mapHistoryManagerTileService',
        'mapHistoryScreeningManagerTileService',
        'mapHistoryOrderTileService',
        'mapHistoryPayChangeTileService',
        'mapHistoryPermStartConfirmationTileService',
        'mapHistoryScreeningCheckItemTileService',
        'mapHistoryScreeningSubcheckTileService',
        'mapHistoryShiftSlotTileService',
        'mapHistorySubmissionTileService',
        'mapHistoryTagApplicationTileService',
        'mapHistoryTimesheetTileService',
        'mapHistoryScreeningCaseTileService',
        'mapHistoryScreeningCaseSubcheckTileService',
        'mapHistoryUnknownTileService',
        'mapHistoryUserTileService',
        'mapHistoryScreeningCandidateTileService',
        'mapHistoryScreeningBusinessRecordTileService',
        'mapScreeningbusinessrecordTileService',
        'mapScreeningmanagerTileService',
        'mapScreeningcandidateTileService',
        'mapScreeningcaseTileService',
        'mapScreeningcasesubcheckTileService',
        'mapLeadTileService',
        'mapOfferTileService'
    ];
    angular.module('app').factory('mapTilesJsonData', mapTilesJsonData);

}());
